import React from 'react'
import { Link } from 'react-router-dom'

const BreadcrumbTwo = () => {
    return (
        <div className="breadcrumb py-26 bg-color-one product-details-breadcrumb">
            <div className="container container-lg">
                <div className="breadcrumb-wrapper flex-between flex-wrap gap-16">
                    <h6 className="mb-0 product-details-breadcrumb-title">Produit details</h6>
                    <ul className="flex-align gap-8 flex-wrap product-details-breadcrumb-list">
                        <li className="text-sm">
                            <Link to="/" className="text-main-600 flex-align gap-8 product-details-breadcrumb-link">
                                <i className="ph ph-house" />
                                Accueil
                            </Link>
                        </li>
                        <li className="flex-align text-gray-500 product-details-breadcrumb-separator">
                            <i className="ph ph-caret-right" />
                        </li>
                        <li className="text-sm">
                            <Link to="/shop" className="text-main-600 flex-align gap-8 product-details-breadcrumb-link">
                                Nos Produits
                            </Link>
                        </li>
                        <li className="flex-align text-gray-500 product-details-breadcrumb-separator">
                            <i className="ph ph-caret-right" />
                        </li>
                        <li className="text-sm text-neutral-600 product-details-breadcrumb-current">Produit Délice du Fès</li>
                    </ul>
                </div>
            </div>
        </div>

    )
}

export default BreadcrumbTwo